import { useEffect } from "react";

import purify from "dompurify";
import { useTranslation } from "pro-features/components/WithTranslation";

import { Button } from "@similarweb/ui-components";
import { Stack, Text } from "@similarweb/ui-components/foundations";

import {
    REACTIVATE_ACCOUNT_DUNNING_EVENT_NAME,
    DUNNINGS_INLINE_BANNER_CTA_LOCATION,
    DUNNINGS_REACTIVATE_ACCOUNT_EVENT_SUB_SUB_NAME,
} from "app/components/Dunnings/dunningsConstants";
import { DunningsSectionWrapper } from "app/components/Dunnings/DunningsStyled";
import { ReactivateAccountDunningList } from "app/components/Dunnings/ReactivateAccountDunningList/ReactivateAccountDunningList";
import { useDunnings } from "app/components/hooks/useDunnings";
import { AssetsService } from "app/services/AssetsService";
import { allTrackers } from "app/services/track/track";

export const ReactivateAccountDunningsSection = () => {
    const translate = useTranslation();
    const { onDunningsButtonClicked } = useDunnings();

    useEffect(() => {
        allTrackers.dispatchTrackEvent(
            "banner",
            "show",
            `${REACTIVATE_ACCOUNT_DUNNING_EVENT_NAME}/${DUNNINGS_INLINE_BANNER_CTA_LOCATION}`,
        );
    }, []);

    return (
        <DunningsSectionWrapper data-automation="reactivate-account-dunnings-section">
            <Stack gap="20px">
                <Stack gap="12px">
                    <Text
                        fontVariant="h4"
                        dangerouslySetInnerHTML={{
                            // eslint-disable-next-line @typescript-eslint/naming-convention
                            __html: purify.sanitize(translate("dunnings.reactivateAccount.modal.title")),
                        }}
                    />

                    <Text
                        fontVariant="body2"
                        type="DM Sans"
                        dangerouslySetInnerHTML={{
                            // eslint-disable-next-line @typescript-eslint/naming-convention
                            __html: purify.sanitize(translate("dunnings.reactivateAccount.modal.text")),
                        }}
                    />
                </Stack>

                <ReactivateAccountDunningList listHeaderText={translate("dunnings.restartTrial.modal.get_access_to")} />

                <Button
                    width="fit-content"
                    type="primary"
                    onClick={() =>
                        onDunningsButtonClicked(
                            `${REACTIVATE_ACCOUNT_DUNNING_EVENT_NAME}/${DUNNINGS_INLINE_BANNER_CTA_LOCATION}/${DUNNINGS_REACTIVATE_ACCOUNT_EVENT_SUB_SUB_NAME}`,
                            "package",
                        )
                    }
                >
                    {translate("dunnings.reactivateAccount.banner.button")}
                </Button>
            </Stack>

            <img
                alt={translate("dunnings.reactivateAccount.modal.image_alt")}
                src={AssetsService.assetUrl("/images/dunnings/unlock_feature.svg")}
            />
        </DunningsSectionWrapper>
    );
};
